export default __webpack_public_path__ + "static/media/weightlossregime_4@3x.49a55b98.jpg";